import React from 'react';

interface ChatToggleButtonProps {
  active: boolean;
  unreadCount: number;
  onClick: () => void;
}

export default function ChatToggleButton({ active, unreadCount, onClick }: ChatToggleButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-3 text-sm font-semibold border-b-2 transition-colors relative ${
        active
          ? 'border-[#62B8E9] text-[#62B8E9]'
          : 'border-transparent text-[#626262] hover:text-[#62B8E9]'
      }`}
    >
      Chatt
      {unreadCount > 0 && (
        <span className="ml-1.5 inline-flex items-center justify-center px-1.5 py-0.5 text-xs font-bold text-white bg-red-500 rounded-full min-w-[20px]">
          {unreadCount}
        </span>
      )}
    </button>
  );
}
